export default __webpack_public_path__ + "static/media/trash.bff254b8.svg";